import { cn } from "@/lib/utils";
import { SVGProps } from "react";

export default function AddIcon(props?: SVGProps<SVGSVGElement>) {
  return (
    <svg
      className={cn("fill-[#0F1324]/[0.6]", props?.className)}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M9.16797 9.1665V4.1665H10.8346V9.1665H15.8346V10.8332H10.8346V15.8332H9.16797V10.8332H4.16797V9.1665H9.16797Z" />
    </svg>
  );
}
